<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">แก้ไขสิ่งมีชีวิตกลายพันธุ์</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-indigo-600 mx-auto"></div>
              <p class="mt-2 text-indigo-200">กำลังโหลดข้อมูล...</p>
            </div>

            <!-- ฟอร์ม -->
            <form v-else @submit.prevent="handleUpdateMutant">
              <div class="space-y-4 h-96 overflow-auto mb-6">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อสิ่งมีชีวิตกลายพันธุ์</label>
                    <input 
                      v-model="mutantData.name" 
                      type="text" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ระดับความหายาก</label>
                    <select 
                      v-model.number="mutantData.rarity" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพสิ่งมีชีวิตกลายพันธุ์</label>
                    <input 
                      v-model="mutantData.img" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/image.jpg"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปหน้าปกติ</label>
                    <input 
                      v-model="mutantData.normalFace" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/normal-face.jpg"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปหน้าที่โมโห</label>
                    <input 
                      v-model="mutantData.angryFace" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/angry-face.jpg"
                    >
                  </div>
                </div>

                <!-- คำพูดที่สิ่งมีชีวิตกลายพันธุ์ชอบพูด -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">คำพูดที่สิ่งมีชีวิตกลายพันธุ์ชอบพูด</h4>
                  <div v-for="(phrase, index) in mutantData.phrases" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-10">
                      <input 
                        v-model="mutantData.phrases[index]" 
                        type="text" 
                        placeholder="คำพูด"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button 
                        v-if="index > 0"
                        @click="removePhrase(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบคำพูด"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button 
                      @click="addPhrase"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มคำพูด
                    </button>
                  </div>
                </div>

                <!-- รายการไอเทมที่ดรอป -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">รายการไอเทมที่ดรอป</h4>
                  <div v-for="(item, index) in mutantData.items" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-4">
                      <input 
                        v-model="item.name" 
                        type="text" 
                        placeholder="ชื่อไอเทม"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-3">
                      <input 
                        v-model.number="item.dropChance" 
                        type="number" 
                        min="0"
                        max="10000"
                        placeholder="โอกาสดรอป (1-10000)"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-3 flex items-center">
                      <label class="flex items-center text-sm text-gray-300">
                        <input 
                          v-model="item.transferable" 
                          type="checkbox" 
                          class="mr-2 bg-gray-700 border-gray-600 focus:ring-indigo-500"
                        >
                        โอนได้
                      </label>
                    </div>
                    <div class="col-span-2">
                      <button 
                        v-if="index > 0"
                        @click="removeItem(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบไอเทม"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button 
                      @click="addItem"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มไอเทม
                    </button>
                  </div>
                </div>

                <!-- รางวัลที่ได้รับ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">รางวัลที่ได้รับ</h4>
                  <div class="grid grid-cols-3 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Silver ที่ได้รับ</label>
                      <input 
                        v-model.number="mutantData.rewards.silver" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Gold ที่ได้รับ</label>
                      <input 
                        v-model.number="mutantData.rewards.gold" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Diamond ที่ได้รับ</label>
                      <input 
                        v-model.number="mutantData.rewards.diamond" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <!-- เพิ่มใหม่: Renown -->
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Renown เมื่อฆ่าสำเร็จ</label>
                      <input 
                        v-model.number="mutantData.rewards.renownKill" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Renown เมื่อจับสำเร็จ</label>
                      <input 
                        v-model.number="mutantData.rewards.renownCatch" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                </div>

                <!-- การจับ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">การจับ</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label class="flex items-center text-sm font-medium mb-1 text-gray-300">
                        <input
                          v-model="mutantData.canCatch"
                          type="checkbox"
                          class="mr-2 bg-gray-700 border-gray-600 focus:ring-indigo-500"
                        >
                        สามารถจับได้
                      </label>
                    </div>
                    <div v-if="mutantData.canCatch">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับความยากในการจับ</label>
                      <select
                        v-model.number="mutantData.catchDifficulty"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                        <option value="1">1 (ง่าย)</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5 (ยาก)</option>
                      </select>
                    </div>
                    <div v-if="mutantData.canCatch">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนครั้งที่สามารถจับได้</label>
                      <input
                        v-model.number="mutantData.catchLimit"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                  <!-- ไอเทมที่ดรอปเมื่อจับสำเร็จ -->
                  <div v-if="mutantData.canCatch" class="space-y-4 mt-4">
                    <h5 class="text-md font-medium text-gray-300">ไอเทมที่ดรอปเมื่อจับสำเร็จ</h5>
                    <div v-for="(item, index) in mutantData.catchItems" :key="'catch-' + index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-4">
                        <input
                          v-model="item.name"
                          type="text"
                          placeholder="ชื่อไอเทม"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-3">
                        <input
                          v-model.number="item.dropChance"
                          type="number"
                          min="0"
                          max="10000"
                          placeholder="โอกาสดรอป (1-10000)"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-3 flex items-center">
                        <label class="flex items-center text-sm text-gray-300">
                          <input
                            v-model="item.transferable"
                            type="checkbox"
                            class="mr-2 bg-gray-700 border-gray-600 focus:ring-indigo-500"
                          >
                          โอนได้
                        </label>
                      </div>
                      <div class="col-span-2">
                        <button
                          v-if="index > 0"
                          @click="removeCatchItem(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบไอเทม"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button
                        @click="addCatchItem"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มไอเทม
                      </button>
                    </div>
                  </div>
                </div>

                <!-- ค่าสถานะ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
                  <div class="grid grid-cols-2 sm:grid-cols-6 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                      <input
                        v-model.number="mutantData.stats.stamina"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                      <input
                        v-model.number="mutantData.stats.str"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                      <input
                        v-model.number="mutantData.stats.int"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                      <input
                        v-model.number="mutantData.stats.agi"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                      <input
                        v-model.number="mutantData.stats.defense"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                      <input
                        v-model.number="mutantData.stats.luck"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button 
                  type="button"
                  @click="handleDeleteMutant"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                  ลบสิ่งมีชีวิตกลายพันธุ์
                </button>
                <button 
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  อัปเดตสิ่งมีชีวิตกลายพันธุ์
                </button>
                <button 
                  @click="$emit('cancelModal')" 
                  type="button" 
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  props: ['mutantId'],
  emits: ['cancelModal', 'mutantUpdated', 'mutantDeleted'],
  setup(props, { emit }) {
    const mutantData = ref({
      name: '',
      img: '',
      normalFace: '',
      angryFace: '',
      phrases: [''],
      items: [{ name: '', dropChance: 0, transferable: false }],
      catchItems: [{ name: '', dropChance: 0, transferable: false }],
      rewards: { silver: 0, gold: 0, diamond: 0, renownKill: 0, renownCatch: 0 }, // ✅ เพิ่ม renownKill, renownCatch
      stats: {
        stamina: 0,
        str: 0,
        int: 0,
        agi: 0,
        defense: 0,
        luck: 0,
      },
      rarity: 1,
      canCatch: false,
      catchDifficulty: 1,
      catchLimit: 1
    });
    const isLoading = ref(true);

    const getRarityColors = (rarityValue) => {
      switch (Number(rarityValue)) {
        case 1: return { bgColor: 'bg-gray-500', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
        case 2: return { bgColor: 'bg-stone-500', textColor: 'text-stone-500', borderColor: 'border-stone-600' };
        case 3: return { bgColor: 'bg-green-500', textColor: 'text-green-500', borderColor: 'border-green-600' };
        case 4: return { bgColor: 'bg-blue-500', textColor: 'text-blue-500', borderColor: 'border-blue-600' };
        case 5: return { bgColor: 'bg-red-500', textColor: 'text-red-500', borderColor: 'border-red-600' };
        default: return { bgColor: 'bg-gray-700', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
      }
    };

    const addPhrase = () => { mutantData.value.phrases.push(''); };
    const removePhrase = (index) => {
      if (mutantData.value.phrases.length > 1) mutantData.value.phrases.splice(index, 1);
    };

    const addItem = () => { mutantData.value.items.push({ name: '', dropChance: 0, transferable: false }); };
    const removeItem = (index) => {
      if (mutantData.value.items.length > 1) mutantData.value.items.splice(index, 1);
    };

    const addCatchItem = () => { mutantData.value.catchItems.push({ name: '', dropChance: 0, transferable: false }); };
    const removeCatchItem = (index) => {
      if (mutantData.value.catchItems.length > 1) mutantData.value.catchItems.splice(index, 1);
    };

    const fetchMutant = async () => {
      try {
        const doc = await projectFirestore.collection('gameMutants').doc(props.mutantId).get();
        if (doc.exists) {
          mutantData.value = { ...doc.data() };
          if (!mutantData.value.phrases || mutantData.value.phrases.length === 0) {
            mutantData.value.phrases = [''];
          }
          if (!mutantData.value.items || mutantData.value.items.length === 0) {
            mutantData.value.items = [{ name: '', dropChance: 0, transferable: false }];
          } else {
            mutantData.value.items = mutantData.value.items.map(item => ({
              ...item,
              transferable: item.transferable ?? false
            }));
          }
          if (!mutantData.value.catchItems || mutantData.value.catchItems.length === 0) {
            mutantData.value.catchItems = [{ name: '', dropChance: 0, transferable: false }];
          } else {
            mutantData.value.catchItems = mutantData.value.catchItems.map(item => ({
              ...item,
              transferable: item.transferable ?? false
            }));
          }
          if (!mutantData.value.rewards) {
            // ✅ เพิ่ม renownKill, renownCatch ตอน rewards เป็น null
            mutantData.value.rewards = { silver: 0, gold: 0, diamond: 0, renownKill: 0, renownCatch: 0 };
          } else {
            // ✅ patch ค่าเก่าที่ยังไม่มี field renown
            mutantData.value.rewards.renownKill = mutantData.value.rewards.renownKill ?? 0;
            mutantData.value.rewards.renownCatch = mutantData.value.rewards.renownCatch ?? 0;
          }
          if (!mutantData.value.stats) {
            mutantData.value.stats = { stamina: 0, str: 0, int: 0, agi: 0, defense: 0, luck: 0 };
          }
          if (mutantData.value.canCatch === undefined) mutantData.value.canCatch = false;
          if (!mutantData.value.catchDifficulty) mutantData.value.catchDifficulty = 1;
          if (!mutantData.value.catchLimit) mutantData.value.catchLimit = 1;
        } else {
          alert('ไม่พบข้อมูลสิ่งมีชีวิตกลายพันธุ์');
          emit('cancelModal');
        }
      } catch (error) {
        console.error('Error fetching mutant:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      } finally {
        isLoading.value = false;
      }
    };

    const handleUpdateMutant = async () => {
      try {
        const mutantName = mutantData.value.name.trim();
        if (!mutantName || /[/\.#$\[\]]/.test(mutantName)) {
          alert('ชื่อสิ่งมีชีวิตกลายพันธุ์ไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }

        const rarityColors = getRarityColors(mutantData.value.rarity);
        const filteredPhrases = mutantData.value.phrases.filter(phrase => phrase.trim());
        const filteredItems = mutantData.value.items.filter(item => item.name && item.dropChance > 0);
        const filteredCatchItems = mutantData.value.canCatch
          ? mutantData.value.catchItems.filter(item => item.name && item.dropChance > 0)
          : [];

        const updateData = {
          name: mutantName,
          img: mutantData.value.img,
          normalFace: mutantData.value.normalFace || '',
          angryFace: mutantData.value.angryFace || '',
          phrases: filteredPhrases,
          items: filteredItems,
          itemNames: filteredItems.map(item => item.name),
          catchItems: filteredCatchItems,
          catchItemNames: filteredCatchItems.map(item => item.name),
          rewards: {
            silver: mutantData.value.rewards.silver || 0,
            gold: mutantData.value.rewards.gold || 0,
            diamond: mutantData.value.rewards.diamond || 0,
            renownKill: mutantData.value.rewards.renownKill || 0,   // ✅ เพิ่ม
            renownCatch: mutantData.value.rewards.renownCatch || 0, // ✅ เพิ่ม
          },
          stats: {
            stamina: mutantData.value.stats.stamina,
            str: mutantData.value.stats.str,
            int: mutantData.value.stats.int,
            agi: mutantData.value.stats.agi,
            defense: mutantData.value.stats.defense,
            luck: mutantData.value.stats.luck,
          },
          rarity: Number(mutantData.value.rarity),
          rarityColors: rarityColors,
          canCatch: mutantData.value.canCatch,
          catchDifficulty: mutantData.value.canCatch ? Number(mutantData.value.catchDifficulty) : 0,
          catchLimit: mutantData.value.canCatch ? Number(mutantData.value.catchLimit) : 0
        };

        const oldId = props.mutantId;
        const newId = mutantName;
        const batch = projectFirestore.batch();
        if (oldId !== newId) {
          batch.delete(projectFirestore.collection('gameMutants').doc(oldId));
          batch.set(projectFirestore.collection('gameMutants').doc(newId), updateData);
        } else {
          batch.update(projectFirestore.collection('gameMutants').doc(oldId), updateData);
        }
        await batch.commit();

        console.log('Mutant updated successfully:', newId);
        emit('cancelModal');
      } catch (error) {
        console.error('Error updating mutant:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };

    const handleDeleteMutant = async () => {
      if (window.confirm('แน่ใจว่าต้องการลบสิ่งมีชีวิตกลายพันธุ์นี้ใช่ไหม? การลบนี้ไม่สามารถย้อนกลับได้')) {
        try {
          await projectFirestore.collection('gameMutants').doc(props.mutantId).delete();
          console.log('Mutant deleted successfully:', props.mutantId);
          emit('mutantDeleted');
          emit('cancelModal');
        } catch (error) {
          console.error('Error deleting mutant:', error);
          alert(`เกิดข้อผิดพลาดในการลบ: ${error.message}`);
        }
      }
    };

    onMounted(fetchMutant);

    return { 
      mutantData,
      isLoading,
      handleUpdateMutant,
      handleDeleteMutant,
      addPhrase,
      removePhrase,
      addItem,
      removeItem,
      addCatchItem,
      removeCatchItem
    };
  }
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>